import * as THREE from 'three';

class World {

  constructor(canvas) {
    this.canvas = canvas;
    this.width = 0;
    this.height = 0;
    this.scene = new THREE.Scene();
    this.camera = this.createCamera();
    this.light = this.createLight();
    this.mesh = this.createBox();
    this.container = new THREE.Object3D();
    this.renderer = new THREE.WebGLRenderer({
      alpha: true,
      antialias: true,
      canvas: this.canvas
    });

    this.scene.add(new THREE.AmbientLight(0xffffff));
    this.scene.add(this.camera);
    this.scene.add(this.light);
    this.scene.add(this.container);

    this.camera.lookAt(this.mesh.position);
  }

  createCamera() {
    const cam = new THREE.PerspectiveCamera(45, this.width / this.height, 0.1, 10000);
    cam.position.set(0.00, 0.00, -5.0);
    cam.lookAt(new THREE.Vector3(0, 0, 0));
    return cam;
  }

  createLight() {
    let light = new THREE.PointLight();
    light.position.set(0.01, 0.01, -0.5);
    return light;
  }

  createBox() {
    const geom = new THREE.BoxGeometry(1,1,1),
          mat = new THREE.MeshNormalMaterial();
    return new THREE.Mesh(geom, mat);
  }

  enableViewer() {
    const onDrag = (e) => {
      this.container.rotation.y += e.movementX * 0.01;
      this.container.rotation.x += e.movementY * 0.01;
    }
    const onWheel = (e) => {
      let zoom = -e.deltaY * 0.005;
      if (this.container.scale.x + zoom <= 0) zoom = 0;
      this.container.scale.x += zoom;
      this.container.scale.y += zoom;
      this.container.scale.z += zoom;
    }
    this.canvas.addEventListener('mousedown', e => {
      this.canvas.addEventListener('mousemove', onDrag)
    });
    this.canvas.addEventListener('mouseup', e => {
      this.canvas.removeEventListener('mousemove', onDrag)
    });
    this.canvas.addEventListener('wheel', onWheel);
  }

  render(time, scene=null, camera=null, renderTarget=null) {
    this.renderer.render(scene || this.scene, camera || this.camera, renderTarget);
  }

  resize() {
    this.width = this.canvas.offsetWidth;
    this.height = this.canvas.offsetHeight;
    this.canvas.width = this.width;
    this.canvas.height = this.height;
    this.camera.aspect = this.width / this.height;
    this.renderer.setSize(this.width, this.height, false);
    this.camera.updateProjectionMatrix();
  }
}
export default World;


// WEBPACK FOOTER //
// ./src/scripts/webgl/World.js